import React from 'react';
import { useAuth } from '../context/AuthContext';
import UserDashboard from './UserDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { user } = useAuth();
  // Default to 'user' if role is missing, ensuring a fallback view is always shown
  const role = user?.role?.toLowerCase() || 'user';

  if (role === 'admin') {
    return <AdminDashboard />;
  }

  // Both 'user' and 'franchise' roles see the UserDashboard
  // Franchise features are accessible via the Franchise submenu in sidebar
  return <UserDashboard />;
};

export default Dashboard;
